import { UserSearch } from "lucide-react";
import { OverviewItem } from "./helper";
import { useState } from "react";

import {
  updateCaseFields,
  validateForensicAuditor,
} from "../logic/validations";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";

import {
  selectCaseHeader,
} from "../logic/Slice";

import { updateCase } from "../../../thunks/Case";
import { ParticipantItem } from "./ParticipantItem";
import { ParticipantType } from "../../../api/participants";
import { showErrorToast } from "../../../lib/toast";

export const KeyStakeHolders: React.FC = () => {

  const dispatch = useAppDispatch();

  const summaryData = useAppSelector(selectCaseHeader);
  const forensicAuditor = summaryData?.forensic_auditor;

  const [forensicAuditorError, setForensicAuditorError] = useState<string | null>(null);


  const saveField = async (field: string, value: any) => { 
    const resultAction = await dispatch(
        updateCase({
          caseId: summaryData?.case_id as string,
          request: { [field]: value },
        })
    );

    if (updateCase.fulfilled.match(resultAction)) {
        return true;
    } else {
        console.error("Update failed:", resultAction.payload);
        showErrorToast("Failed to update. Try again.");
        return false;
    }
 };

  const onSaveForensicAuditor = async (value: string) => {
    const error = validateForensicAuditor(value);
    setForensicAuditorError(error);
    if (!error) {
      return await saveField(updateCaseFields.FORENSIC_AUDITOR, value.trim());
    } else {
      return false;
    }
  };

  return (
    <div className="space-y-4">

      <div className="flex items-center gap-1">
        <span className="text-xs font-normal leading-4 text-[#0A0A0A] font-sans">
          Key Stakeholders
        </span>
      </div>

      <div className="space-y-3 px-2">
        <ParticipantItem type={ParticipantType.CASE_INITIATOR} />
        <ParticipantItem type={ParticipantType.FORWARDING_AUTHORITY} />
        <ParticipantItem type={ParticipantType.CASE_DEALING_OFFICER} />
        <ParticipantItem type={ParticipantType.IO_APPOINTING_AUTHORITY} />
        <ParticipantItem type={ParticipantType.INVESTIGATOR} />        
        <OverviewItem
          icon={<UserSearch />}
          label="Forensic Auditor"
          isVertical
          type="text"
          value={forensicAuditor}
          inputPlaceholder="Enter name"
          inputError={forensicAuditorError}
          isEditable
          onSave={onSaveForensicAuditor}
          field={updateCaseFields.FORENSIC_AUDITOR}
        />        
      </div>
    </div>
  );
};